export default __webpack_public_path__ + "static/media/veqtor_circle-stroke.d68772dc.svg";